import {
    FETCH_BRANCHES_CONTENT,
    FETCH_BRANCHES_CONTENT_SUCCESS,
    FETCH_BRANCHES_CONTENT_FAILED,
    BRANCH_DELETE__MESSAGE,
    BRANCH_DELETE_MESSAGE_SUCCESS,
    BRANCH_DELETE__MESSAGE_FAILED
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_BRANCHES_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_BRANCHES_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_BRANCHES_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case BRANCH_DELETE__MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case BRANCH_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case BRANCH_DELETE__MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        default:
            return state;
    }
}
